module.exports = __webpack_public_path__ + "img/selected1-min.2b804e23.png";